import React from 'react';
import { FileText, Users, CheckCircle } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      icon: FileText,
      title: 'Submit Your Case',
      description: 'Share your legal needs through our secure online form or schedule a consultation with our team.',
    },
    {
      icon: Users,
      title: 'Get Expert Consultation',
      description: 'Our experienced attorneys will review your case and provide strategic recommendations tailored to your situation.',
    },
    {
      icon: CheckCircle,
      title: 'Legal Execution',
      description: 'We execute the legal strategy with precision, keeping you informed at every step until successful completion.',
    },
  ];

  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      data-testid="how-it-works-section"
      style={{
        backgroundImage: 'url(https://images.pexels.com/photos/5668858/pexels-photo-5668858.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="absolute inset-0 bg-[#2C3E50]/90"></div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="text-center mb-16">
          <div className="text-sm uppercase tracking-[0.2em] font-medium text-[#CA9A67] mb-4">
            How It Works
          </div>
          <h2 className="text-3xl lg:text-4xl tracking-tight text-white font-bold mb-4">
            Three Simple Steps to Legal Success
          </h2>
          <p className="text-base leading-relaxed text-white/70 max-w-2xl mx-auto">
            Our streamlined process ensures you receive expert legal guidance quickly and efficiently.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mobile-swiper">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 text-center hover:bg-white/10 transition-all duration-300 group" data-testid={`step-${index + 1}`}>
                <div className="inline-flex items-center justify-center w-20 h-20 bg-[#CA9A67] rounded-full mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-10 h-10 text-white" strokeWidth={1.5} />
                </div>
                <div className="text-sm uppercase tracking-[0.2em] font-medium text-[#CA9A67] mb-3">
                  Step {index + 1}
                </div>
                <h3 className="text-xl lg:text-2xl text-white font-semibold mb-3">
                  {step.title}
                </h3>
                <p className="text-base leading-relaxed text-white/70">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
